import {
  AccessRestrictionsAccessRestrictionModel,
  AccessRestrictionsAccessRestrictionModelAccessTypesEnum,
  AccessRestrictionsAccessRestrictionModelOperationTypesEnum
} from '../generated/access-restrictions-access-restriction-model';

export type AccessRestriction = AccessRestrictionsAccessRestrictionModel;
export type AccessTypesEnum = AccessRestrictionsAccessRestrictionModelAccessTypesEnum;
export type OperationTypesEnum = AccessRestrictionsAccessRestrictionModelOperationTypesEnum;
export const AccessTypes = AccessRestrictionsAccessRestrictionModelAccessTypesEnum;
export const OperationTypes = AccessRestrictionsAccessRestrictionModelOperationTypesEnum;
